// AU/NZ-only phone widget for the member pages:
//   * sign-up    - templates/users/register.html
//   * my details - templates/users/profile.html + templates/users/users/show.html
//
// This is the original site-wide intl-tel-input setup, kept as-is for those two
// pages: only Australia and New Zealand are offered, and each page's own inline
// validatePhoneNumber() does the mobile-number checks and writes the E.164 value
// into the hidden custom field. Generic CMS forms are handled by ./form-phone.js,
// which accepts any country - it skips inputs carrying data-phone-au-nz so the
// two never double-initialise the same field.

import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';

const phoneNumberField = document.querySelector('input[type="tel"][data-phone-au-nz]');

if (phoneNumberField) {
	const iti = intlTelInput(phoneNumberField, {
		countryOrder: ['au', 'nz'],
		separateDialCode: true,
		nationalMode: true,
		strictMode: true,
		onlyCountries: ['au', 'nz'],
		useFullscreenPopup: false,
		customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
			let placeholder = '4xx xxx xxx';
			if (selectedCountryData.dialCode == 64) {
				placeholder = '2x xxx xxxx';
			} else if (JSON.stringify(selectedCountryData) == '{}') {
				placeholder = '';
			}
			return placeholder;
		},
	});

	window.iti = iti; // exposed in case it is needed elsewhere, as before
}
